import { SET_USER_DATA } from "../../types/UserData";

export const setUserData = ( payload ) => ({
  type: SET_USER_DATA,
  payload: payload,
});
